export default __webpack_public_path__ + "static/media/IMG-20221012-WA0010 - Lisha Garg.900452bb.jpg";